import React from 'react';
import DatasheetPreview from './DatasheetPreview';
import USDatasheetPreview from './USDatasheetPreview';
import { sheetHasPage2 } from '../datasheet';

// A pack page is a US kit sheet when it carries a `us` payload and we are in US mode.
export const isUsPackSheet = (data, region) => region === 'US' && !!(data && data.us);

// Pages a datasheet contributes to the pack (AU: 1-2, US: however many kit pages).
export function packPageNodes(wrapper) {
  if (!wrapper) return 1;
  const n = wrapper.querySelectorAll('.ds-page').length;
  return n || 1;
}

// One datasheet inside a project / proposal pack. Annotation overlays are AU-only.
export default function PackSheet({ data, pageId, region, overlay, overlay2 }) {
  if (isUsPackSheet(data, region)) return <USDatasheetPreview sheet={data} pageId={pageId} />;
  return <DatasheetPreview sheet={data} pageId={pageId} overlay={overlay} overlay2={overlay2} />;
}

export const auPageCount = (data) => 1 + (sheetHasPage2(data) ? 1 : 0);
